import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const {
    language,
    t
  } = useLanguage();
  const getLink = (path: string) => {
    if (language === 'en') {
      return path === '/' ? '/' : path;
    }
    return `/${language}${path}`;
  };
  return <footer className="w-full py-8 px-6 md:px-12 bg-[var(--color-dark)]" data-id="element-143">
      <div className="max-w-7xl mx-auto" data-id="element-144">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-145">
          {/* Logo — clip saarone subtitle from bottom */}
          <div className="flex items-center" data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/4nkahh2hNsVZTnNq46Gbps/elvora_logo_cutout.png" alt="ELVORA" className="h-12 w-auto brightness-0 invert" style={{
            clipPath: 'inset(0 0 18% 0)'
          }} data-id="element-147" />
          </div>

          {/* Navigation - Companies first */}
          <nav className="flex flex-wrap items-center justify-center gap-2" data-id="element-148">
            <a href={getLink('/for-companies')} className="px-4 py-2 text-sm font-medium text-white rounded-full border border-gray-600 hover:border-gray-500 transition-colors text-center" data-id="element-149">
              {t('header.forCompanies')}
            </a>
            <a href={getLink('/for-seafarers')} className="px-4 py-2 text-sm font-medium text-white rounded-full border border-gray-600 hover:border-gray-500 transition-colors text-center" data-id="element-150">
              {t('header.forSeafarers')}
            </a>
          </nav>

          {/* CTA Buttons with links */}
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto" data-id="element-151">
            <a href={getLink('/for-companies')} className="px-5 py-2.5 bg-[var(--color-tan)] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity text-center" data-id="element-152">
              {t('footer.discussTask')}
            </a>
            <a href={getLink('/for-seafarers')} className="px-5 py-2.5 bg-[var(--color-tan)] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity text-center" data-id="element-153">
              {t('footer.sendProfile')}
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="my-6 border-t border-gray-700" data-id="element-154"></div>

        {/* Social Links */}
        <div className="flex flex-wrap justify-center gap-4 mb-6" data-id="element-155">
          <a href="https://t.me/elvora" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-156">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-157">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" data-id="element-158" />
            </svg>
            <span className="text-sm" data-id="element-159">Telegram</span>
          </a>
          <a href="viber://chat?number=+380" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-160">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-161">
              <circle cx="12" cy="12" r="10" data-id="element-162" />
            </svg>
            <span className="text-sm" data-id="element-163">Viber</span>
          </a>
          <a href="https://wa.me/380" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-164">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-165">
              <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0012.04 2z" data-id="element-166" />
            </svg>
            <span className="text-sm" data-id="element-167">WhatsApp</span>
          </a>
          <a href="mailto:info@elvora.com" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-168">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-169">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-170" />
            </svg>
            <span className="text-sm" data-id="element-171">Email</span>
          </a>
        </div>

        {/* Bottom row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center" data-id="element-172">
          <p className="text-sm text-gray-500" data-id="element-173">© ELVORA</p>
          <div className="flex gap-4 text-sm text-gray-500" data-id="element-174">
            <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-175">
              {t('footer.privacy')}
            </a>
            <span data-id="element-176">|</span>
            <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-177">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}